<script >
const __sfc_main = {};
__sfc_main.props = {
  filtersCount: {
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    emit
  };
};
export default __sfc_main;
</script>

<template>
    <nav class="charting-mobile-bottom-bar" aria-label="Herramientas del graficador">
        <button type="button" @click="emit('open-filters')">
            <span class="charting-mobile-bottom-bar__icon"><i class="pi pi-filter"></i><b v-if="filtersCount">{{ filtersCount }}</b></span>
            <span>Explorar</span>
        </button>
        <button type="button" @click="emit('open-workspaces')">
            <span class="charting-mobile-bottom-bar__icon"><i class="pi pi-folder-open"></i></span>
            <span>Workspaces</span>
        </button>
    </nav>
</template>

<style scoped>
.charting-mobile-bottom-bar { position: fixed; z-index: 1000; right: 0; bottom: 0; left: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); border-top: 1px solid var(--charting-b-border-color); background: color-mix(in srgb, var(--charting-b-panel-bg-strong) 96%, transparent); padding: 0.4rem max(0.75rem, env(safe-area-inset-right)) max(0.4rem, env(safe-area-inset-bottom)) max(0.75rem, env(safe-area-inset-left)); box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.1); backdrop-filter: blur(16px); }
.charting-mobile-bottom-bar button { display: flex; min-height: 3.3rem; align-items: center; justify-content: center; gap: 0.55rem; border: 0; border-radius: 0.85rem; background: transparent; color: var(--p-text-color); font-size: 0.78rem; font-weight: 800; cursor: pointer; }
.charting-mobile-bottom-bar button:active { background: var(--charting-b-hover-bg); }
.charting-mobile-bottom-bar__icon { position: relative; font-size: 1.05rem; }
.charting-mobile-bottom-bar__icon b { position: absolute; top: -0.55rem; right: -0.65rem; display: grid; min-width: 1.05rem; height: 1.05rem; place-items: center; border-radius: 999px; background: var(--brand-primary); color: white; font-size: 0.58rem; }
</style>
